export const BANK_SUPER_ADMIN = 'BANK_SUPER_ADMIN'
export const BANK_CORPORATE_ADMIN = 'BANK_CORPORATE_ADMIN'
export const BANK_ADMIN = 'BANK_ADMIN'
export const BANK_OPERATOR = 'BANK_OPERATOR'
export const BANK_CORPORATE_AUTHORIZER = 'BANK_CORPORATE_AUTHORIZER'
export const BANK_AUTHORIZER = 'BANK_AUTHORIZER'
export const CORPORATE_ADMIN = 'CORPORATE_ADMIN'
export const CORPORATE_AUTHORIZER = 'CORPORATE_AUTHORIZER'
export const CORPORATE_OPERATOR = 'CORPORATE_OPERATOR'
export const PAYDO_ADMIN = 'PAYDO_ADMIN'
export const PAYDO_MANAGER = 'PAYDO_MANAGER'
export const PAYDO_USER = 'PAYDO_USER'
export const MODULE_CAMPAIGN='MODULE_CAMPAIGN'
export const MODULE_FILE='MODULE_FILE'
export const MODULE_CORPORATE='MODULE_CORPORATE'
export const MODULE_BANK = 'MODULE_BANK'
export const MODULE_USER = 'MODULE_USER'
export const MODULE_REPORT = 'MODULE_REPORT'
export const OPERATION_CREATE='OPERATION_CREATE'
export const OPERATION_APPROVE='OPERATION_APPROVE'
export const OPERATION_EDIT='OPERATION_EDIT'
export const OPERATION_VIEW = 'OPERATION_VIEW'
export const OPERATION_SEND = 'OPERATION_SEND'
export const OPERATION_DELETE = 'OPERATION_DELETE'
export const OPERATION_DISABLE = 'OPERATION_DISABLE'
export const OPERATION_CONTO_EDIT = 'OPERATION_CONTO_EDIT'
export const OPERATION_CONTO_VIEW = 'OPERATION_CONTO_VIEW'
export const OPERATION_DOWNLOAD = 'OPERATION_DOWNLOAD'
export const OPERATION_REUPLOAD = 'OPERATION_REUPLOAD'
export const OPERATION_HISTORY = 'OPERATION_HISTORY'
export const OPERATION_ERROR = 'OPERATION_ERROR'
export const OPERATION_TYPE_READ='OPERATION_TYPE_READ'
export const OPERATION_TYPE_WRITE='OPERATION_TYPE_WRITE'
export const FILE_STATUS_DRAFT='DRAFT'
export const FILE_STATUS_BANK_CORPORATE_VERIFIED='BANK_CORPORATE_VERIFIED'
export const FILE_STATUS_BANK_CORPORATE_VERIFIED_2='BANK_CORPORATE_VERIFIED_2'
export const FILE_STATUS_BANK_CORPORATE_VERIFIED_1='BANK_CORPORATE_VERIFIED_1'
export const FILE_STATUS_BANK_CORPORATE_AUTHORIZER_VERIFIED='BANK_CORPORATE_AUTHORIZER_VERIFIED'
// export const FILE_STATUS_BANK_AUTHORIZER_VERIFIED='BANK_AUTHORIZER_VERIFIED'
export const FILE_STATUS_BANK_AUTHORIZER_VERIFIED_1='BANK_AUTHORIZER_VERIFIED_1'
export const FILE_STATUS_BANK_AUTHORIZER_VERIFIED_2='BANK_AUTHORIZER_VERIFIED_2'
export const FILE_STATUS_FINAL_APPROVED='FINAL_APPROVED'
export const FILE_STATUS_SEND_OK='SENT_OK'
export const FILE_STATUS_SEND_KO='SENT_KO'
export const FILE_STATUS_ACQUIRED='ACQUIRED'
export const FILE_STATUS_NOT_ACQUIRED='NOT_ACQUIRED'
export const FILE_STATUS_REJECTED='REJECTED'

export function checkRole(role, module, operation, flag) {
    let allowed = false;
    if( role === ''){
        allowed=false;
    } else if(role === PAYDO_ADMIN){
        if (operation === OPERATION_APPROVE ||
            operation === OPERATION_SEND) {
            allowed = false;
        }else{
            allowed = true;
        }
        if (module === MODULE_CAMPAIGN) {
            if (operation === OPERATION_CREATE ||
                operation === OPERATION_ERROR ||
                operation === OPERATION_APPROVE) {
                allowed=false;
            }
        }
        if (module === MODULE_FILE) {
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_ERROR ||
                    operation === OPERATION_APPROVE) {
                    allowed = false;
                }
            }
        }
    } else if(role === PAYDO_MANAGER){
        if(module === MODULE_USER){
            allowed=true;
        } else if (module === MODULE_BANK) {
            if (operation === OPERATION_CREATE ||
                operation === OPERATION_ERROR) {
                allowed=false;
            } else if (operation === OPERATION_VIEW ||
                       operation === OPERATION_EDIT) {
                allowed=true;
            }
        } else if (module === MODULE_CORPORATE) {
            if (operation === OPERATION_VIEW ||
                operation === OPERATION_EDIT ||
                operation === OPERATION_CREATE){
                allowed=true;
            }else{
                allowed=false;
            }
        } else if (module === MODULE_CAMPAIGN) {
            if (operation === OPERATION_CREATE ||
                operation === OPERATION_ERROR) {
                allowed=false;
            } else if (operation === OPERATION_VIEW ||
                       operation === OPERATION_EDIT) {
                allowed=true;
            }
        }
        else if (module === MODULE_REPORT) {
            allowed = flag;
        } else if (module === MODULE_FILE) {
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_ERROR) {
                    allowed = false;
                } else if (operation === OPERATION_VIEW ||
                           operation === OPERATION_EDIT) {
                    allowed = true;
                }
            }
        }
    }else if(role === PAYDO_USER){
        if (module === MODULE_BANK ||
            module === MODULE_CORPORATE ||
            module === MODULE_CAMPAIGN ||
            module === MODULE_USER) {
            if (operation === OPERATION_CREATE ||
                operation === OPERATION_ERROR) {
                allowed=false;
            } else if (operation === OPERATION_VIEW ||
                       operation === OPERATION_EDIT) {
                allowed=true;
            }
        } else if (module === MODULE_REPORT) {
            allowed = flag;
        } else if (module === MODULE_FILE) {
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_ERROR) {
                    allowed = false;
                } else if (operation === OPERATION_VIEW ||
                           operation === OPERATION_EDIT) {
                    allowed = true;
                }
            }
        }
    } else if(role === BANK_SUPER_ADMIN){
        if(module === MODULE_BANK){
            allowed=true;
        }else if(module === MODULE_USER){
            allowed=true;
        } else if (module=== MODULE_CORPORATE ||
                   module === MODULE_CAMPAIGN) {
            allowed = false;
        } else if (module === MODULE_REPORT) {
            allowed = flag;
        } else if (module === MODULE_FILE) {
            if (flag === true) {
            allowed =false;
        }
        }
    } else if (role === BANK_CORPORATE_ADMIN) {
        if (module === MODULE_CORPORATE) {
            if (operation === OPERATION_VIEW ||
                operation === OPERATION_CREATE ||
                operation === OPERATION_EDIT ||
                operation === OPERATION_DELETE ||
                operation === OPERATION_CONTO_EDIT ||
                operation === OPERATION_CONTO_VIEW) {
                allowed = true;
            }else if(operation === OPERATION_APPROVE){
                allowed = false;
            }
        } else if (module === MODULE_USER) {
            allowed=true
        } else if (module === MODULE_REPORT) {
            allowed = flag;
        } else if(module === MODULE_FILE){
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_APPROVE ||
                    operation === OPERATION_ERROR) {
                allowed=false;
            }else{
                allowed=true;
            }
        }

        }
    }else if(role === BANK_CORPORATE_AUTHORIZER){
        if(module === MODULE_FILE){
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_EDIT ||
                    operation === OPERATION_ERROR) {
                allowed=false
            }else{
                allowed=true
            }
        }
        }
        if (module === MODULE_REPORT) {
            allowed = flag;
        }
    } else if (role === BANK_ADMIN) {
        if (module === MODULE_CORPORATE ||
            module === MODULE_CAMPAIGN) {
          allowed=true;
      }else if(module===MODULE_FILE){
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_APPROVE ||
                    operation === OPERATION_ERROR) {
              allowed=false;
          }else {
              allowed=true;
          }
          }
      } else if (module === MODULE_REPORT) {
            allowed = flag;
      }
    } else if(role === BANK_AUTHORIZER){
        if(module === MODULE_FILE){
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_EDIT ||
                    operation === OPERATION_ERROR) {
                allowed=false
            }else{
                allowed=true
            }
        }
        } else if (module === MODULE_REPORT) {
            allowed = flag;
        }
    } else if(role === BANK_OPERATOR){
        if(module === MODULE_FILE){
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_EDIT ||
                    operation === OPERATION_VIEW ||
                    operation === OPERATION_ERROR) {
                allowed=true
            }
        }
        } else if (module === MODULE_REPORT) {
            allowed = flag;
    }
    } else if (role === CORPORATE_ADMIN) {
        if(module === MODULE_CORPORATE){
            if (operation === OPERATION_EDIT ||
                operation === OPERATION_VIEW ||
                operation === OPERATION_DELETE ||
                operation === OPERATION_CONTO_VIEW) {
                allowed = true;
            }
        } else if (module === MODULE_CAMPAIGN ||
                   module === MODULE_USER) {
            if (operation === OPERATION_CREATE ||
                operation === OPERATION_EDIT ||
                operation === OPERATION_VIEW ||
                operation === OPERATION_DELETE ||
                operation === OPERATION_CONTO_VIEW) {
                allowed = true;
            }
        } else if (module === MODULE_FILE) {
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_ERROR) {
                allowed = false;
                } else if (operation === OPERATION_EDIT ||
                           operation === OPERATION_VIEW) {
                allowed = true;
            }
            }
        }else if(module === MODULE_REPORT){
            allowed = flag;
        }

    } else if(role === CORPORATE_OPERATOR){
        if(module === MODULE_FILE ){
            if (flag === true) {
                if (operation === OPERATION_CREATE ||
                    operation === OPERATION_VIEW ||
                    operation === OPERATION_SEND ||
                    operation === OPERATION_ERROR) {
                allowed = true;
            }
        }
        } else if (module === MODULE_REPORT) {
            allowed = flag;
        }

    } else if(role === CORPORATE_AUTHORIZER){
        if(module === MODULE_FILE){
            if (flag === true) {
                if (operation === OPERATION_VIEW ||
                    operation === OPERATION_APPROVE) {
                allowed = true;
            }
        }
        } else if (module === MODULE_REPORT) {
            allowed = flag;
    }
    }
    return allowed;
}

export function getStatus(role,fileStatus){
    switch(role){
        case BANK_CORPORATE_AUTHORIZER:
            return FILE_STATUS_BANK_CORPORATE_AUTHORIZER_VERIFIED;
        case CORPORATE_AUTHORIZER:
            if(fileStatus==='DRAFT'){
                return FILE_STATUS_BANK_CORPORATE_VERIFIED_1;
            }else if(fileStatus==='BANK_CORPORATE_VERIFIED_1'){
                return FILE_STATUS_BANK_CORPORATE_VERIFIED_2;
            }else if(fileStatus==='ERROR'){
                return FILE_STATUS_REJECTED;
            }
        case BANK_AUTHORIZER:
            if(fileStatus==='DRAFT'){
                return FILE_STATUS_BANK_AUTHORIZER_VERIFIED_1;
            }else if(fileStatus==='BANK_AUTHORIZER_VERIFIED_1'){
                return FILE_STATUS_BANK_AUTHORIZER_VERIFIED_2;
            }else if(fileStatus==='ERROR'){
                return FILE_STATUS_REJECTED;
            }
        default:
            return
    }
}

export function  getRejectedStatus() {
    return FILE_STATUS_REJECTED;
}

export function checkApproval(role,status,authorizationType){
    if((role === CORPORATE_AUTHORIZER || role === CORPORATE_ADMIN) && (status  === FILE_STATUS_BANK_CORPORATE_VERIFIED || status === FILE_STATUS_FINAL_APPROVED || status === FILE_STATUS_SEND_OK )){
        return true;
    }else if((role === CORPORATE_AUTHORIZER) && (status===FILE_STATUS_BANK_CORPORATE_VERIFIED_1 && authorizationType ==='SINGLE_AUTHORIZATION')){
        return true;
    }else if((role === BANK_ADMIN) && (status === FILE_STATUS_FINAL_APPROVED || status === FILE_STATUS_SEND_OK || status === FILE_STATUS_DRAFT) ){
        return  true;
    }else if((role === BANK_CORPORATE_AUTHORIZER) && (status  === FILE_STATUS_DRAFT || status === FILE_STATUS_FINAL_APPROVED || status === FILE_STATUS_SEND_OK )){
        return  true;
    }else if((role === BANK_CORPORATE_AUTHORIZER) && (status===FILE_STATUS_BANK_CORPORATE_VERIFIED_1 && authorizationType === "DOUBLE_AUTHORIZATION")){
        return true;
    }
    return false;

}

export function checkEdit(role) {
    if(role===CORPORATE_AUTHORIZER || role===CORPORATE_OPERATOR || role===BANK_OPERATOR){
        return true
    }
    return false;
}

export function checkRequired(role,module) {
    if(module === MODULE_CORPORATE){
        if(role === BANK_OPERATOR || role === BANK_AUTHORIZER ||
            role === CORPORATE_ADMIN || role === CORPORATE_AUTHORIZER || role === CORPORATE_OPERATOR){
            return true
        }
        return false;
    }else if(module === MODULE_BANK){
        if(role === BANK_SUPER_ADMIN || role === BANK_CORPORATE_AUTHORIZER ||role === BANK_CORPORATE_ADMIN ||
            role === BANK_ADMIN || role === BANK_AUTHORIZER ||
            role === CORPORATE_ADMIN || role === CORPORATE_AUTHORIZER || role === CORPORATE_OPERATOR){
            return true;
        }
        return false;
    }
}

export function checkBankCorporates(bankId) {
    if(bankId !== undefined || bankId !== null){
        return true;
    }
    return false;

}
export function checkDisabled(role,module) {
    if(role === BANK_CORPORATE_ADMIN || role === BANK_CORPORATE_AUTHORIZER
        ||role === BANK_ADMIN
        || role === BANK_SUPER_ADMIN){
        if(module === MODULE_BANK){
            return false
        }
        return true;
    }else if(role === BANK_AUTHORIZER || role=== BANK_OPERATOR){
        return false;
        // if(module === MODULE_BANK){
        //     return false
        // }
    } else if(role === PAYDO_ADMIN || role === PAYDO_MANAGER || role === PAYDO_USER){
        return true;
    }
    return false
}



export function checkBankDisabledReport(role,module) {
    if(role === BANK_ADMIN || role === CORPORATE_ADMIN){
        return true;
    }else if(role === PAYDO_ADMIN){
        return false;
    }
    return false
}

export function checkCorporateDisabledReport(role,module) {
    if(role === CORPORATE_ADMIN){
        return true;
    }else if(role === PAYDO_ADMIN || role === BANK_ADMIN){
        return false;
    }
    return false
}

export function isCorporateUser(role) {
    if(role === CORPORATE_ADMIN || role === CORPORATE_AUTHORIZER || role === CORPORATE_OPERATOR ){
        return true;
    }else{
        return false;
    }

}

export function isBankAndCorporateUser(role) {
    if(role === BANK_SUPER_ADMIN || role === BANK_CORPORATE_ADMIN || role === BANK_CORPORATE_AUTHORIZER
        || role === CORPORATE_ADMIN || role === CORPORATE_AUTHORIZER || role === CORPORATE_OPERATOR
        || role === BANK_ADMIN || role === BANK_AUTHORIZER || role === BANK_OPERATOR ){
        return true;
    }else{
        return false;
    }

}


export function isPayDoAdmin(role) {
    if(role === PAYDO_ADMIN){
        return true;
    }
    return false;

}

export function getBankCount(banks) {
    let count=0
    count=banks.length;
    return count;
}


export function isCorporateEditableForCampaign(role){
    if(role === BANK_ADMIN){
        return false;
    }
    return true;
}

export function checkCorporateAccess(userCorporates,senderId,opType){
    let access=false;
    if(undefined !== userCorporates){
        userCorporates.map((corporate)=>{
            if(corporate.corporateSenderId === senderId){
                if(opType===OPERATION_TYPE_READ){
                    access=corporate.read
                }else if(opType===OPERATION_TYPE_WRITE){
                    access=corporate.write
                }
            }
        })
    }
    return access;
}



